import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import Listagem from './Sections/listagem';
import EventosAnteriores from './Sections/eventos-anteriores';
import { fetchData } from '../../../Api';
import { EventInterface } from '../../Services/types';

const ListagemEventos: React.FC<any> = ({initialData} : any) => {
    console.log(initialData?.events === undefined, initialData);
    function proccessEvents()
    {
        if(initialData == null || initialData?.events === undefined){
            return null;
        }
        
        const formattedEvents = initialData?.events.map((event: EventInterface) => ({
            ...event,
            data: new Date(event.data),
        })) ?? [];

        return formattedEvents;
    }

    function proccessPastEvents()
    {
        if(initialData == null || initialData?.events === undefined){
            return [];
        }

        const formattedPastEvents = initialData?.past_events.map((past_events: EventInterface) => ({
            ...past_events,
            data: new Date(past_events.data),
        }));

        return formattedPastEvents;
    }

    const [events, setEvents] = useState<EventInterface[]>(proccessEvents());
    const [past_events, setPastEvents] = useState<EventInterface[]>(proccessPastEvents());

    useEffect(() => {    
        const loadData = async () => {
            const response = await fetchData(`eventos`);
            if(response){
                if (response.events) {
                    const formattedEvents = response.events.map((event: EventInterface) => ({
                        ...event,
                        data: new Date(event.data),
                    }));
                    setEvents(formattedEvents);
                }
                if (response.past_events) {
                    const formattedPastEvents = response.past_events.map((past_events: EventInterface) => ({
                        ...past_events,
                        data: new Date(past_events.data),
                    }));
                    setPastEvents(formattedPastEvents);
                }
            }
        };  
        loadData();
    }, []);

    const title = 'Agenda de Eventos';

    const breadcrumb = [{
        name: title,
        slug: 'agenda-de-eventos'
    }];

    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} />
                {events && 
                    <Listagem events={events}/>
                }
                {past_events && 
                    <EventosAnteriores past_events={past_events}/>
                }
            </ MainLayout>
        </>
    );
};

export default ListagemEventos;
